import React from "react";
import { Box, Typography, Avatar, Card, CardContent } from "@mui/material";
import { FormatQuote } from "@mui/icons-material";

const gold = "#C29D59";
const darkBg = "#111";
const lightText = "#000";

const testimonials = [
  {
    name: "Aarav Mehta",
    role: "Homeowner, Bengaluru",
    content:
      "Zenova has completely transformed my mornings! The classes are calming, and the instructors are incredibly supportive. I feel more balanced and energetic every day.",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Sanya Kapoor",
    role: "Restaurant Owner, Mumbai",
    content:
      "The guided meditations and yoga programs at Zenova helped me connect with myself on a deeper level. I recommend it to anyone looking to relieve stress.",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "Vikram Rao",
    role: "Corporate Client, Hyderabad",
    content:
      "A perfect blend of peace and practice. Zenova’s approach to holistic wellness is refreshing — it’s not just exercise, it’s a lifestyle shift.",
    avatar: "https://randomuser.me/api/portraits/men/65.jpg",
  },
 
  
];

const Testimonials = () => {
  return (
    <Box
      id="testimonials"
      sx={{
       
        color: "#fff",
        py: 10,
        px: { xs: 3, md: 8 },
        textAlign: "start",
      }}
    >
      {/* Heading */}
      <Typography variant="subtitle2" sx={{ color:"#000", textTransform: "uppercase", letterSpacing: 1 }}>
        ➜ Testimonials
      </Typography>

      <Typography variant="h5" sx={{ mb: 1,color:"#000",fontSize:{sm:"40px",xs:"32px"} }}>
        Our Members Speak for Us 
      </Typography>

      <Typography sx={{ color: "#000", maxWidth: 800,  mb: 4 }}>
        Don't just take our word for it. Here's what our satisfied clients  have to say <br /> about their experience.
      </Typography>

      {/* Cards container using Box (flex-wrap) */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          justifyContent: "center",
        }}
      >
        {testimonials.map((t, idx) => (
          <Box
            key={idx}
            sx={{
              // responsive width: 1 column on xs, 2 on sm, 3 on md+
              mt:4,
              width: { xs: "100%", sm: "48%", md: "31.33%" },
              minWidth: { md: "310px" }, // prevents extremely narrow cards on very wide screens with many gaps
            }}
          >
            <Card
              sx={{
                backgroundColor: "#F4F4F4",
                color: "#000",
                boxShadow:"none",
                borderRadius: 3,
                border: "1px solid rgba(255,255,255,0.06)",
                p: 2,
             
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                transition: "transform 0.28s ease, box-shadow 0.28s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.45)",
                },
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <FormatQuote sx={{ fontSize: 38, color: "#000", mb: 1 }} />
                <Typography
                  variant="body1"
                  sx={{ color: lightText, mb: 4, fontStyle: "italic", lineHeight: 1.6 }}
                >
                  “{t.content}”
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
                  <Avatar
                    src={t.avatar}
                    alt={t.name}
                    sx={{ width: 56, height: 56, border: `2px solid ${gold}` }}
                  />
                  <Box sx={{ textAlign: "left" }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#000" }}>
                      {t.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: lightText }}>
                      {t.role}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Testimonials;
